import {StateSaver, StateChanges, BlankState} from './stateChanges'
import {RunStates} from './runStates'
import router from '../router'
import {firebaseStore} from './firebaseModule'
import {assignChosenStringLetterArrayAndSpecialNikud} from '../js/letterOperations'
import {stringWithoutNikud} from '../js/commonHebrew'

window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}

function applyWordChanges(state, newWordContainer) {
  let wordObj = state.allWorkingNikud.wordsArray[newWordContainer.index]
  // console.log('wordObj:')
  // console.log(wordObj)
  // console.log('newWordContainer:')
  // console.log(newWordContainer)
  Object.assign(wordObj, newWordContainer.changes)
  assignChosenStringLetterArrayAndSpecialNikud(wordObj, state)
}

// the following two "constants" are used only in the "Pro" Nakdan
const FIREBASE_KEY_BADCHARS = [".", "#", "$", "/", "[", "]", "\n"]
const prefixes = [
  {words: 'words', entry: 'entry', letters: 'letters'},
  {words: 'negativeWords', entry: 'negativeEntry', letters: 'negativeLetters'}
]

const basicMutations = {
  [StateChanges.SET_ENTIRE_STATE] (state, commitObj) {
    this.replaceState(JSON.parse(commitObj.newStateJson))
  },
  [StateChanges.NAKDAN_RUNNING] (state) {
    state.nakdanApiState = RunStates.RUNNING
  },
  [StateChanges.SET_NAKDAN_RESULTS]: function (state, responseData) {
    state.nakdanApiResponse = responseData
    state.nakdanApiState = RunStates.COMPLETE
    if (router.currentRoute.name !== 'nikud-edit') {
      state.allWorkingNikud.wordsArray = []
      state.currentPositionData.wordIndex = -1
      StateSaver.saveState(state)
      router.push({name: 'nikud-edit'})
    }
  },
  [StateChanges.NAKDAN_FAILED]: function (state) {
    state.nakdanApiState = RunStates.FAILED
  },
  [StateChanges.NAKDAN_TIMED_OUT]: function (state) {
    state.nakdanApiState = RunStates.TIMED_OUT
  },
  [StateChanges.GENRE_CLASSIFY_RUNNING] (state) {
    state.genreClassifyApiState = RunStates.RUNNING
  },
  [StateChanges.SET_GENRE_CLASSIFY_RESULTS]: function (state, responseData) {
    state.originalDocument.identifiedGenre = responseData.genre
    state.genreClassifyApiState = RunStates.COMPLETE
  },
  [StateChanges.GENRE_CLASSIFY_FAILED]: function (state) {
    state.genreClassifyApiState = RunStates.FAILED
  },
  [StateChanges.GENRE_CLASSIFY_TIMED_OUT]: function (state) {
    state.genreClassifyApiState = RunStates.TIMED_OUT
  },
  [StateChanges.LOAD_DOCUMENT_FILE]: function (state, documentFile) {
    state.originalDocument.source = documentFile;
    gtag("event", "load file", {
      'event_category': 'user input',
      'event_label': 'loaded file of type: ' + documentFile.type
    })
  },
  [StateChanges.EDIT_DOCUMENT_TEXT]: function (state, editedText) {
    state.originalDocument.text = editedText.text;
    if (editedText.nullifySource) state.originalDocument.source = null;
    if (state.originalDocument.text === '') state.originalDocument.id = BlankState.originalDocument.id
  },
  [StateChanges.SET_TEXT_FOR_NAKDAN_API_CALL]: function (state, newText) {
    state.textForNakdanApiCall.text = newText
    if (newText === state.originalDocument.text) state.originalDocument.id = Math.random()
  },
  [StateChanges.STORE_ALL_FRONTEND_NIKUD_OPTIONS]: function (state, options) {
    state.preSubmissionOptions = options;
  },
  [StateChanges.STORE_ALL_WORKING_NIKUD]: function (state, commitObj) {
    state.allWorkingNikud = JSON.parse(commitObj.newAllWorkingNikudJson)
    state.allWorkingNikud.id = state.originalDocument.id
    state['wordIdToIndexMap'] = {}
    state.allWorkingNikud.wordsArray.forEach((wordObj, i) => {
      state.wordIdToIndexMap[i] = i
      assignChosenStringLetterArrayAndSpecialNikud(wordObj, state)
    })
  },
  [StateChanges.REWRITE_WORD_IN_WORKING_ARRAY]: function (state, commitObj) {
    applyWordChanges(state, commitObj.newWordContainer)
    if (commitObj.nextWordContainer) applyWordChanges(state, commitObj.nextWordContainer)
  },
  [StateChanges.REWRITE_WORD_TO_RUN_AND_POS_MAP]: function (state, newMap) {
    state.originalDocument.source.wordToRunAndPosMap = newMap
  },
  [StateChanges.SPLICE_WORDS_IN_WORKING_ARRAY]: function (state, commitObj) {
    state.allWorkingNikud.wordsArray.splice(
      commitObj.spliceWordsContainer.startIndex, commitObj.spliceWordsContainer.toDelete, ...(commitObj.spliceWordsContainer.spliceWordsArray))
    state.allWorkingNikud.lastWordId += commitObj.spliceWordsContainer.spliceWordsArray.length
    state.allWorkingNikud.wordsArray.forEach((wordObj, i) => {
      state.wordIdToIndexMap[wordObj.wordId] = i
      assignChosenStringLetterArrayAndSpecialNikud(wordObj, state)
    })
    if (commitObj.nextWordContainer) applyWordChanges(state, commitObj.nextWordContainer)
  },
  [StateChanges.SET_CURRENT_WORD_INDEX]: function (state, newIndex) {
    state.currentPositionData.wordIndex = newIndex;
  },
  [StateChanges.VALIDATION_FAILURE_POPUP_SHOWN]: function (state) {
    state.validationResult.popupShown = true;
  },
  [StateChanges.SET_CURRENT_LETTER_INDEX]: function (state, newIndex) {
    state.currentPositionData.letterIndex = newIndex;
  },
  [StateChanges.SET_WORD_AND_LETTER]: function (state, indicesObj) {
    state.currentPositionData.wordIndex = indicesObj.word
    state.currentPositionData.letterIndex = indicesObj.letter
  },
  [StateChanges.SET_SHOW_AIMS]: function (state, newShowAims) {
    state.postSubmissionOptions.showAims = newShowAims;
  },
  [StateChanges.SET_DISABLE_GO_HOME_PROMPT]: function (state, newDisableGoHomePrompt) {
    state.postSubmissionOptions.disableGoHomePrompt = newDisableGoHomePrompt;
  },
  [StateChanges.SET_DISABLE_BACK_TO_TEXT_PREP_PROMPT]: function (state, newDisableBackToTextPrepPrompt) {
    state.postSubmissionOptions.disableBackToTextPrepPrompt = newDisableBackToTextPrepPrompt;
  },
  [StateChanges.SET_DISABLE_SWITCH_GENRE_PROMPT]: function (state, newDisableSwitchGenrePrompt) {
    state.postSubmissionOptions.disableSwitchGenrePrompt = newDisableSwitchGenrePrompt;
  },
  [StateChanges.SET_ALL_POST_SUBMISSION_OPTIONS]: function (state, newPostSubmissionOptions) {
    state.postSubmissionOptions = Object.assign({}, newPostSubmissionOptions);
  },
  // the below mutations are used only in the "Pro" Nakdan
  [StateChanges.UPDATE_USER_DICTIONARY] (state, commitObj) {
    if (commitObj.newUserDictionaryJson) state.userDictionary = JSON.parse(commitObj.newUserDictionaryJson)
    prefixes.forEach(prefix => {
      if (commitObj[prefix.words + 'ToDelete']) commitObj[prefix.words + 'ToDelete'].forEach(word => {
        delete state.userDictionary[prefix.entry + 'Present'][word]
        const lettersMap = state.userDictionary[prefix.letters + 'Map'][stringWithoutNikud(word)]
        lettersMap.splice(lettersMap.indexOf(word), 1)
      }) // note: "delete"s need to be BEFORE "add"s [for NikudOptionsPane.moveShownOptionToTop()]
      if (commitObj[prefix.words + 'ToAdd']) commitObj[prefix.words + 'ToAdd'].forEach(word => {
        if (FIREBASE_KEY_BADCHARS.every(badChar => !(word.includes(badChar)))) {
          state.userDictionary[prefix.entry + 'Present'][word] = true
          const withoutNikud = stringWithoutNikud(word)
          if (state.userDictionary[prefix.letters + 'Map'][withoutNikud]) {
            state.userDictionary[prefix.letters + 'Map'][withoutNikud].unshift(word)
          } else state.userDictionary[prefix.letters + 'Map'][withoutNikud] = [word]
        } else console.log('word with bad character cannot be added to user dictionary: ' + JSON.stringify(word))
      })
    })
    firebaseStore('dictionary', 
      Object.keys(state.userDictionary.entryPresent)
        .concat(Object.keys(state.userDictionary.negativeEntryPresent)).length 
          ? state.userDictionary : null)
  },
  [StateChanges.SET_DISABLE_UPLOAD_DICTIONARY_PROMPT]: function (state, newDisableUploadDictionaryPrompt) {
    state.postSubmissionOptions.disableUploadDictionaryPrompt = newDisableUploadDictionaryPrompt;
  },
  [StateChanges.SET_SHOW_NIKUD_BUTTONS]: function (state, newShowButtons) {
    state.postSubmissionOptions.showNikudButtons = newShowButtons;
  },
  [StateChanges.SET_NIKUD_KEYBOARD]: function (state, newNikudKeyboard) {
    state.postSubmissionOptions.nikudKeyboard = newNikudKeyboard;
  },
  'emptyState': function () {
    this.replaceState(BlankState)
  }
}

export default basicMutations
